export const getCookieName = (config, key) => {
  return `${config.public.grouperFrontendCookiePrefix || ''}${key}`
}
